// Request Freight Availability only applies to a cargo that offers FOB together
// with a delivered incoterm (CFR/DAP/CIF): the freight cost is what makes the FOB
// offer comparable. A cargo with FOB only has nothing to compare against.
// Mirrors BE Helpers/General/FreightRequirement.cs.

const DELIVERED_INCOTERMS = ['CFR', 'DAP', 'CIF'];

const incotermName = line =>
  String(line?.incoterm ?? '')
    .trim()
    .toUpperCase();

export const isFobIncoterm = line => incotermName(line) === 'FOB';

export const isDeliveredIncoterm = line =>
  DELIVERED_INCOTERMS.includes(incotermName(line));

// lines: the cargo's incoterm rows, each with an `incoterm` name.
export const cargoNeedsFreight = (lines = []) =>
  lines.some(isFobIncoterm) && lines.some(isDeliveredIncoterm);
